const home = { name: "<< Back to home", path: "/", isActive: true };
const myhome = { name: "Home", path: "/", isActive: false };

const events = {
  name: "Events",
  path: "/events",
  isActive: true,
};

const event_details = {
  name: "Event Details",
  path: null,
  isActive: true,
};
const expertManpower = {
  name: "Expert Manpower",
  path: "/expert-manpower",
  isActive: true,
};

const expertManpower_details = {
  name: "Expert Manpower Details",
  path: null,
  isActive: true,
};
const candidates = {
  name: "Candidates",
  path: "/candidates",
  isActive: true,
};

const candidate_details = {
  name: "Candidate Details",
  path: null,
  isActive: true,
};
const downloaded_candidates = {
  name: "Downloaded Profiles",
  path: "/candidate-profiles",
  isActive: true,
};
const advisor_list = {
  name: "Advisors",
  path: "/advisors",
  isActive: true,
};
const advisor_details = {
  name: "Advisor Detail",
  path: null,
  isActive: true,
};

const downloaded_candidate_details = {
  name: "Candidate Details",
  path: null,
  isActive: true,
};
const resoursePerssonal = {
  name: "Resource Personnel",
  path: "/resource-personal",
  isActive: true,
};

const resoursePerssonal_details = {
  name: "Resource Personnel Details",
  path: null,
  isActive: true,
};
const governing_body = {
  name: "Governing Body",
  path: null,
  isActive: true,
};
const executive_council = {
  name: "Executive Council",
  path: null,
  isActive: true,
};
const core_team = {
  name: "Core Team",
  path: null,
  isActive: true,
};
const incentives = {
  name: "Incentives",
  path: null,
  isActive: true,
};
const contact = {
  name: "RTI",
  path: null,
  isActive: true,
};
const faq = {
  name: "FAQ",
  path: null,
  isActive: true,
};

module.exports = {
  home: [myhome],
  events: [myhome, events],
  eventDetails: [myhome, events, event_details],
  homeeventDetails: [myhome, events, event_details],
  expertManpower_details: [myhome, expertManpower, expertManpower_details],
  candidates_details: [myhome, candidates, candidate_details],
  advisor_list: [myhome, advisor_list],
  advisor_details: [myhome, advisor_list, advisor_details],
  downloaded_candidates_details: [
    myhome,
    downloaded_candidates,
    downloaded_candidate_details,
  ],
  resoursePerssonalDetails: [
    myhome,
    resoursePerssonal,
    resoursePerssonal_details,
  ],
  governingBody: [myhome, governing_body],
  executiveCouncil: [myhome, executive_council],
  advisors: [myhome, advisor_list],
  coreTeam: [myhome, core_team],
  incentives: [myhome, incentives],
  contact: [myhome, contact],
  faq: [myhome, faq],
};
